import { Component, inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { BusyService } from "~app/common/components/busy/busy.service";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { CommonTexts } from "~app/common/texts/common.texts";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { RaskCommonModule } from "../../../../../common/rask-common.module";
import { ChecklistaTexts } from "./sysadm-checklist.texts";
import { SysadmChecklistaItemComponent } from "./sysadm-checklista-item/sysadm-checklista-item.component";
import { SysadmEditFragaDialogComponent } from "./sysadm-edit-fraga-dialog/sysadm-edit-fraga-dialog.component";
import { SysadmLaggtillGruppComponent } from "./sysadm-laggtill-grupp/sysadm-laggtill-grupp.component";
import { ChecklisteFragaAdminDTO, ChecklistGruppAdminDTO } from "./sysadm.checklista.models";
import { SysdamChecklistaService } from "./sysdam-checklista.service";

@Component({
    selector: "rask-sysadm-checklista",
    imports: [
        RaskCommonModule,
        SysadmChecklistaItemComponent
    ],
    templateUrl: "./sysadm-checklista.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./sysadm-checklista.component.scss"
})
export class SysadmChecklistaComponent implements OnInit {
    texts = ChecklistaTexts.texts;
    commonTexts = CommonTexts.texts;

    private _grupperWithFragor: ChecklistGruppAdminDTO[] = [];
    private readonly raskModalService = inject(RaskModalService);
    private readonly sysadmChecklistaService = inject(SysdamChecklistaService);
    private readonly busyService = inject(BusyService);

    set grupperWithFragor(val: ChecklistGruppAdminDTO[]) {
        const copy = [...val];
        copy.sort((a, b) => a.sekvensnummer - b.sekvensnummer);
        this._grupperWithFragor = copy;
    }

    get grupperWithFragor(): ChecklistGruppAdminDTO[] {
        return this._grupperWithFragor;
    }

    ngOnInit(): void {
        this.busyService.addWork(this.sysadmChecklistaService.getAllGrupperWithFragor())
            .subscribe(grupper => {
                this.grupperWithFragor = grupper;
            });
    }

    protected openEditFragaModal = (fraga?: ChecklisteFragaAdminDTO) => {
        this.raskModalService.openAsync(this.texts.editFraga, SysadmEditFragaDialogComponent, "lg", true, fraga)
            .subscribe((result: ChecklisteFragaAdminDTO) => {
                if (ObjectUtils.isNullOrUndefined(result)) {
                    return;
                }

                const updatedGruppIndex = this.grupperWithFragor.findIndex(g => g.id === result.gruppId);
                const grupp = this.grupperWithFragor[updatedGruppIndex];
                const fragaIndex = grupp.fragor.findIndex(f => f.id === result.id);

                if (fragaIndex > -1) {
                    grupp.fragor = [
                        ...grupp.fragor.slice(0, fragaIndex),
                        result,
                        ...grupp.fragor.slice(fragaIndex + 1)
                    ];
                } else {
                    grupp.fragor = [
                        ...grupp.fragor,
                        result
                    ];
                }
            });
    };

    protected openAddGruppModal = () => {
        this.raskModalService.openAsync(this.texts.addGrupp, SysadmLaggtillGruppComponent, "lg", true)
            .subscribe((result: ChecklistGruppAdminDTO) => {
                if (ObjectUtils.isNullOrUndefined(result)) {
                    return;
                }

                this.grupperWithFragor = [
                    ...this.grupperWithFragor,
                    result
                ];
            });
    };

    protected onGruppRemoved(grupp: ChecklistGruppAdminDTO) {
        this.grupperWithFragor = this.grupperWithFragor.filter(x => x.id !== grupp.id);
    }
}
